import { combineReducers } from '@reduxjs/toolkit';
import { pageModelReducer } from './page-model';
import { allBrandsReducer } from './all-brands/ducks';
import { brandFilterReducer } from './brands-filter/ducks/brands-filter-slice';

export const featuresReducer = combineReducers({
  pageModel: pageModelReducer,
  allBrands: allBrandsReducer,
  brandsFilter: brandFilterReducer,
});
